<div class="chart-card">
    <h3 class="chart-title">{{ title | translate }}</h3>
    <div class="chart-container">
        <canvas baseChart
            *ngIf="currentData.length > 0"
            type="line"
            [data]="chartData"
            [options]="chartOptions">
        </canvas>
        <div *ngIf="currentData.length === 0" class="no-data">
            {{ 'request_v2.analytics.no_data' | translate }}
        </div>
    </div>
</div>
